import { render } from "./MediaList.vue?vue&type=template&id=c0d476c6&scoped=true"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"

import "./MediaList.vue?vue&type=style&index=0&id=c0d476c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d476c6"]])

export default __exports__